import React, { useEffect, useState } from 'react';
import ProgressSteps from './progressSteps';
import { useEmployee } from '../../context/EmployeeContext';
import { updateEmployeeDetails } from '../../api/employeesApi';
import { NavLink } from 'react-router-dom';

const StepTwo = ({ setStepFromUrl }) => {

    const { employeeData, setEmployeeData } = useEmployee();

    const [form, setForm] = useState({
      routineNumber: '',
      accountNumber: '',
      confirmAccountNumber: '',
      accountType: 'Checking',
      paymentMethod: 'DirectDeposit',
    });
  
    const [errors, setErrors] = useState({});
    const companyId = "com_7833dc4d76ffef1190cb6045bdc7c168";
    const employeeId = "emp_a52d155da005f01190cb6045bdc7c168";
  
    useEffect(() => {
        if (employeeData) {
          setForm({
            routineNumber: employeeData.bankAccounts?.[0]?.routineNumber || '',
            accountNumber: employeeData.bankAccounts?.[0]?.accountNumber || '',
            confirmAccountNumber: employeeData.bankAccounts?.[0]?.accountNumber || '',
            accountType: employeeData.bankAccounts?.[0]?.accountType || 'Checking',
            paymentMethod: employeeData.defaultPaymentMethod || 'DirectDeposit',
          });
        }
      }, [employeeData]);
      
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setForm((prev) => ({ ...prev, [name]: value }));
    };
  
    const validate = () => {
      const newErrors = {};
      if (!form.routineNumber.trim()) newErrors.routineNumber = "Routine Number is required";
      if (!form.accountNumber.trim()) newErrors.accountNumber = "Account Number is required";
      if (!form.confirmAccountNumber.trim()) newErrors.confirmAccountNumber = "Confirm Account Number is required";
      if (form.accountNumber !== form.confirmAccountNumber)
        newErrors.confirmAccountNumber = "Account numbers do not match";
      return newErrors;
    };
  
    const handleContinue = async () => {
      const validationErrors = validate();
      setErrors(validationErrors);
      if (Object.keys(validationErrors).length !== 0) return;
  
      try {
        const payload = {
          bankInfo: {
            routineNumber: form.routineNumber,
            accountNumber: form.accountNumber,
            accountType: form.accountType,
          },
          defaultPaymentMethod: form.paymentMethod,
        };
  
        await updateEmployeeDetails(companyId, employeeId, payload);
        setEmployeeData({ ...employeeData, ...payload });
        setStepFromUrl(3);
      } catch (err) {
        console.error("Failed to update bank info", err);
        alert("Something went wrong, please try again.");
      }
    };

    return (
        <div >
            <ProgressSteps currentStep={2} />
            <div>
                <h5 className="mb-2 sub-title">Linked Bank Accounts</h5>
                <p className="gray-text-for-content mb-4">You can deposit and split your wages across multiple bank accounts (up to 7).</p>
            </div>
            <div>
                <h5 className="mb-2 sub-title">Add Bank Account</h5>
                <div className="mb-4  bg-white rounded ">
                    <div className='row'>
                        <div className="mb-4 col-4 custom-radio-wrapper">
                            <input
                                className="custom-radio"
                                type="radio"
                                name="accountType"
                                value="Checking"
                                checked={form.accountType === "Checking"}
                                onChange={handleChange}
                            />
                            <label className="gray-text-for-content m-0" >
                                Checking
                            </label>
                        </div>
                        <div className="mb-4 col-4 custom-radio-wrapper">
                            <input
                                className="custom-radio"
                                type="radio"
                                name="accountType"
                                value="Savings"
                                checked={form.accountType === "Savings"}
                                onChange={handleChange}
                            />
                            <label className="gray-text-for-content m-0" >
                                Savings
                            </label>
                        </div>

                    </div>

                    <div className='row'>
                        <div className="mb-4 col-4">
                            <label className="d-block text-start">Routine Number</label>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    name="routineNumber"
                                    value={form.routineNumber}
                                    onChange={handleChange}
                                    placeholder="Enter Routine Number"
                                    className={`input-base gray-text-for-content`}
                                />
                            </div>
                        </div>
                        <div className="mb-4 col-4">
                            <label className="d-block text-start">Account Number</label>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    value=""
                                    placeholder="Enter Account Number"
                                    className={`input-base gray-text-for-content`}
                                />
                            </div>
                        </div>
                        <div className="mb-4 col-4">
                            <label className="d-block text-start">Confirm Account Number</label>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    name="accountNumber"
                                    value={form.accountNumber}
                                    onChange={handleChange}
                                    placeholder="Enter Confirm Account Number"
                                    className={`input-base gray-text-for-content`}
                                />
                               {errors.routineNumber && <small className="text-danger">{errors.routineNumber}</small>}
                            </div>
                        </div>
                    </div>
                    <p className='gray-text-for-content' style={{ fontSize: "10px" }}>Don't want to manually enter your bank information?<span style={{ color: "#005AE2" }}> Connect via Plaid</span></p>
                </div>
            </div>
            <div>
                <h5 className="mb-2 sub-title">Change Payment Method</h5>
                <p className='gray-text-for-content' style={{ fontSize: "10px" }}>How would you like to be paid?</p>
               
                <div className="mb-2  bg-white rounded row">
             
                        <div className="mb-4 col-4 custom-radio-wrapper">
                            <input
                                className="custom-radio"
                                type="radio"
                                name="paymentMethod"
                                value="DirectDeposit"
                                checked={form.paymentMethod === "DirectDeposit"}
                                onChange={handleChange}
                            />
                            <label className="gray-text-for-content m-0" >
                            By direct deposit
                            </label>
                        </div>
                        <div className="mb-4 col-4 custom-radio-wrapper">
                            <input
                                className="custom-radio"
                                type="radio"
                                name="paymentMethod"
                                value="Manual"
                                checked={form.paymentMethod === "Manual"}
                                onChange={handleChange}
                            />
                            <label className="gray-text-for-content m-0" >
                            Manually by my employer
                            </label>
                        </div>             
                </div>
            </div>
            <div>
                <div className=' row' >
                    <div className='col-4 d-flex justify-content-between align-items-center' style={{ border: "1px solid #DFF2DD", background: "#F6FFF5", padding: "10px", borderRadius: "10px", margin: "0px 10px 0px 13px" }}>
                        <p className='gray-text-for-content mb-2'>{form.accountType} - ****</p>
                        <button className="green-button">Active</button>
                    </div>
                </div>
            </div>
            <div className="text-center mt-4">
                <NavLink
                    type="button"
                    to={'/manage-employee'}
                    className="cancel-button px-4 mx-2 text-decoration-none"
                >
                    Cancel
                </NavLink>
                <button type="button" onClick={handleContinue} className="dark-orange-button px-4">
                Continue
                </button>
            </div>
        </div>
    );



};

export default StepTwo;